module.exports = __webpack_public_path__ + "static/logo-dgfip-square-bdea2d96a4ba4ee5cf49810f84304c63.png";